<!-- 延保简介 -->
<template>
  <div class="ml_instroductoin">
    <div class="ml_instroductoin_title">
      <div class="ml_instroductoin_close" @click="onclose()"></div>
    </div>
    <div class="ml_instroduction_des">
      本服务由<label class="ml_instroduction_des_bold">「博车网」</label>为用户出具《车辆评估报告》，作为用户开展二手车交易或检测评估等事宜的参考，并与<label class="ml_instroduction_des_bold">「中国人保」</label>一同为报告中“车辆风险等级”判断结果的准确性、“重大事故、水淹、火烧”的风险排查情况进行保障。
    </div>
    <div class="ml_instroduction_card">
      <div class="ml_instroduction_card_title">
        车辆风险等级
      </div>
      <div class="ml_instroduction_card_content">
        <div>A：单次最高车损赔付比例＜5%</div>
        <div>B：5%≤单次最高车损赔付比例＜20%</div>
        <div>C：20%≤单次最高车损赔付比例＜45%</div>
        <div>D：45%≤单次最高车损赔付比例＜80%</div>
        <div>E：单次最高车损赔付比例≥80%</div>
      </div>
      <div class="ml_instroduction_card_title">
        保障范围
      </div>
      <div class="ml_instroduction_card_content">
        在保障服务有效期内，该车辆发生首次交易后，用户因报告中“车辆风险等级”判断结果的准确性问题（即车辆风险等级达到“C\D\E”，博车网未判断出）、或“重大事故、水淹、火烧”的风险排查情况与事实不符而遭受了经济损失，可向本平台提供相应证明材料进行索赔。最高赔付10万元。
      </div>
      <div class="ml_instroduction_card_title">
        保障服务有效期
      </div>
      <div class="ml_instroduction_card_content">
        投保之日起 90 天。
      </div>
    </div>

    <div class="ml_instroduction_card">
      <div class="ml_instroduction_card_title">
        赔偿标准
      </div>
      <div class="ml_instroduction_card_content">
        赔偿金额 = 车辆交易价格 - 车辆折旧金额 - 最终处置价值 - 免赔金额
      </div>
    </div>

    <div class="ml_instroduction_card">
      <div class="ml_instroduction_card_title">
        理赔流程
      </div>
      <div class="ml_instroduction_card_content">
        <div>1、用户在车辆首次交易完成后的90天内向博车网提出理赔申请。</div>
        <div>2、博车网确认收到理赔申请并通知用户提交相关证明材料。</div>
        <div>3、用户于10个工作日内向博车平台提交相关证明材料。</div>
        <div>4、博车网审核材料并向用户收集车辆拍卖处置所需材料。</div>
        <div>5、博车网拍卖处置车辆并向用户进行赔偿。</div>
      </div>
    </div>

    <div class="ml_instroduction_button" @click="onOpenAll()">查看完整条款</div>

    <div class="ml_instroduction_tip">*本服务由博车网提供，客服电话：<label class="ml_instroduction_tip_tel" @click="onTel()">{{ tel }}</label></div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      tel: "400-062-2899"
    }
  },
  methods: {
    onTel() {
      window.location.href = "tel:" + this.tel;
    },
    onOpenAll() {
      // location.href = location.origin + "/#/termWarranty";
      location.href = `carwins://go?url=${process.env.VUE_APP_COMMON_URL}termWarranty?nativetitle=1`;
    },
    onclose() {
      location.href = "carwins://go?close";
    }
  }
}
</script>

<style lang="scss">
.ml_instroductoin {
  background: url(../../../assets/extendedWarranty/bg.png) no-repeat top center;
  background-size: 100% auto;
  background-color: #f5f2f0;
  border-radius: 15px 15px 0 0;

  .ml_instroductoin_title {
    background: url(../../../assets/extendedWarranty/top_bg.png) no-repeat top
      left;
    background-size: 100% auto;
    height: 18px;
    padding: 20px 0;
    position: sticky;
    top: 0;
    z-index: 9;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 58px;
      background: url(../../../assets/extendedWarranty/title.png) no-repeat
        center center;
      background-size: auto 18px;
    }
    .ml_instroductoin_close {
      position: absolute;
      left: 0;
      top: 50%;
      width: 14px;
      height: 14px;
      transform: translateY(-50%);
      background: url(../../../assets/extendedWarranty/close.png) no-repeat
        center center;
      background-size: 14px 14px;
      z-index: 10;
      padding: 20px;
    }
  }

  .ml_instroduction_des {
    color: #692c03;
    text-align: justify;
    line-height: 20px;
    padding: 0 15px 5px 15px;
    text-indent: 2em;
    font-size: 14px;
    .ml_instroduction_des_bold {
      color: #000000;
      font-weight: bold;
    }
  }
  .ml_instroduction_card {
    margin: 10px 15px;
    padding: 12px 15px 12px 30px;
    background-color: #ffffff;
    border-radius: 8px;
    .ml_instroduction_card_title {
      color: #000000;
      font-weight: bold;
      line-height: 20px;
      margin-bottom: 5px;
      position: relative;
      &::before {
        content: "●";
        position: absolute;
        left: -15px;
        top: -2px;
      }
    }
    .ml_instroduction_card_content {
      font-size: 15px;
      color: #666666;
      line-height: 25px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .ml_instroduction_button {
    color: #0645ad;
    padding: 10px 0 10px 0;
    text-align: center;
  }
  .ml_instroduction_tip {
    color: #939190;
    text-align: center;
    padding-bottom: 20px;
    .ml_instroduction_tip_tel {
      color: #ff6600;
    }
  }
}
</style>